<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Импорт меню</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-stepper v-model="step" vertical flat class="elevation-0 card-border">
        <v-stepper-step :complete="step > 1" step="1">Выберите файл меню
          <small>{{ menuFileName }}</small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
            <v-text-field label="Файл меню" @click="pickFile" v-model="menuFileName" prepend-icon="attach_file"></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="menuinput"
              accept=".xml"
              @change="onFilePicked"
            >
          </v-flex>
          <v-btn color="primary" @click="step = 2" :disabled="!menuFile">Далее</v-btn>
          <v-btn text class="mx-2" @click="drop">Сброс</v-btn>
        </v-stepper-content>

        <v-stepper-step :complete="step > 2" step="2">
          Выберите дату, на которую загружается меню
          <small>{{ day }}</small>
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-card flat class="pa-2">
            <v-date-picker
            locale="ru" first-day-of-week="1" @input="() => setDay()"
            v-model="date"
            landscape
            class="mt-3"
            :allowed-dates="allowedDates"
            ></v-date-picker>
          </v-card>
          <v-btn color="primary" @click="() => { step = 3; validate() }" :disabled="!day || step !== 2">Далее</v-btn>
          <v-btn text class="mx-2" @click="drop">Сброс</v-btn>
        </v-stepper-content>

        <v-stepper-step :complete="step > 3" step="3">
          Проверка данных
          <small v-if="step > 3">ok</small>
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-card flat class="pa-2">
            <v-alert v-if="alerts.length === 0 && step === 3"
              type="success"
              :value="true">
              Данные впорядке
            </v-alert>
            <v-alert
              v-for="alert in alerts"
              :type="alert.type"
              :value="true" :key="alert.id"
              >
              {{alert.text}}
            </v-alert>
          </v-card>
          <v-btn color="primary"
            @click="() => { step = 4; uploadMenu() }"
            :disabled="alerts.filter(x => x.type === 'warning' || x.type === 'error').length > 0 || step !== 3"
          >Далее</v-btn>
          <v-btn text class="mx-2" @click="drop">Отмена</v-btn>
        </v-stepper-content>

        <v-stepper-step :complete="step > 4" step="4">Ожидайте загрузки меню</v-stepper-step>
        <v-stepper-content step="4">
          <v-list class="mb-5 pa-2">
            <v-subheader>{{ state }}</v-subheader>
            <v-card v-for="msg in progress" class="my-1" flat :key="msg.id" :color="msg.type">
              <v-subheader :color="msg.type" class="white--text">
                <v-icon>info</v-icon>
                &nbsp;&nbsp;&nbsp;
                {{msg.text}}
              </v-subheader>
            </v-card>
          </v-list>
          <v-btn color="primary" :disabled="!completed" @click="drop">Готово</v-btn>
          <v-btn text class="mx-2" v-if="errored" @click="drop">Отмена</v-btn>
        </v-stepper-content>

      </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const moment = require('moment')
export default {
  data: () => ({
    // ui
    step: 1,
    date: null,
    menuFileName: '',
    alerts: [],
    menuFile: '',
    i: 0,
    encoding: 'utf-8',
    encodings: ['utf-8', 'CP1251'],
    // data
    day: null,
    menuData: '',
    xml: null,
    progress: [],
    state: '',
    completed: false,
    errored: false
  }),
  methods: {
    setDay () {
      const date = moment(this.date).format('YYYY-MM-DD')
      console.log('set date: ', date)
      this.day = date
    },
    pickFile () {
      this.$refs.menuinput.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.menuFileName = files[0].name
        if (this.menuFileName.lastIndexOf('.') <= 0) {
          return
        }
        const fr1 = new FileReader()
        fr1.readAsText(files[0], 'utf-8')
        fr1.addEventListener('load', () => {
          if (fr1.result.includes('utf')) {
            this.menuData = fr1.result
            this.menuFile = files[0]
          }
        })
        const fr2 = new FileReader()
        fr2.readAsText(files[0], 'CP1251')
        fr2.addEventListener('load', () => {
          if (fr2.result.includes('windows')) {
            this.menuData = fr2.result
            this.menuFile = files[0]
          }
        })
      } else {
        this.drop()
      }
    },
    drop () {
      this.step = 1
      this.menuFileName = ''
      this.menuFile = ''
      this.menuData = ''
      this.date = null
      this.day = null
      this.completed = false
      this.errored = false
      this.progress = []
      this.alerts = []
      this.xml = null
      this.state = ''
    },
    allowedDates (val) {
      return moment().subtract(1, 'day').isBefore(val) && moment().add(1, 'month').isAfter(val)
    },
    validate () {
      if (this.menuFileName.includes('20') && !this.menuFileName.includes(this.day.split('-').join(''))) {
        this.alerts.push({ type: 'warning', text: 'Дата в названии файла не соответствует выбранной' })
      }
      if (!this.menuData.startsWith('<?xml')) {
        this.alerts.push({ type: 'warning', text: 'Неверный формат меню' })
        return
      }
      try {
        console.log(this.menuData)
        const parser = new DOMParser()
        this.xml = parser.parseFromString(this.menuData, 'text/xml')
      } catch (err) {
        console.log(err)
        this.alerts.push({ type: 'warning', text: err })
        this.alerts.push({ type: 'warning', text: 'Неверный формат меню' })
      }
      if (this.alerts.filter(x => x.type === 'warning' || x.type === 'error').length === 0 && this.step !== 4) {
        this.step = 4
        this.uploadMenu()
      }
    },
    log (text, type) {
      this.progress.push({
        id: ++this.i, text, type: type || 'primary'
      })
    },
    setState (val) {
      this.state = val
      console.log(val)
    },
    isBudget (title) {
      const lower = title.toLowerCase()
      const budget = (
        lower.includes('м/о') ||
        lower.includes('овз') ||
        lower.includes('по дотации') ||
        lower.includes('бюджет') ||
        lower.includes('льгот')
      )
      if (budget === true) console.log(`budget detected: ${title}`)
      return budget
    },
    async uploadMenu () {
      try {
        const xml = this.xml
        const day = this.day
        const body = xml.getElementsByTagName('Заголовок')[0]
        const dayTag = body.getElementsByTagName('ДатаФормирования')[0].childNodes[0].nodeValue
        if (!(this.menuFileName.includes('20')) && dayTag !== day) {
          this.log(`ДатаФормирования =${dayTag} не соответствует выбранной =${day}`, 'error')
          this.errored = true
          return
        }
        const { menu } = await this.$store.dispatch('sioRequest', {
          topic: 'org-menu',
          pl: { day }
        })
        console.log(menu)
        const cafes = Object.keys(menu)
        for (let cafeNode of body.getElementsByTagName('Столовая')) {
          const cafeid = parseInt(cafeNode.getElementsByTagName('Код')[0].childNodes[0].nodeValue)
          const statePrefix = `В обработке: Столовая ${cafeid}`
          this.setState(statePrefix)
          if (!cafes.includes(cafeid.toString())) {
            this.log(`Столовая ${cafeid} не найдена и будет пропущена`, 'warning')
          } else {
            for (let groupNode of cafeNode.getElementsByTagName('ГруппаТовара')) {
              try {
                let groupTitle
                let groupСode
                try {
                  groupTitle = groupNode.getElementsByTagName('Наименование')[0].childNodes[0].nodeValue
                } catch (e) {
                  console.log(e)
                  throw new Error(`Столовая ${cafeid}: группа будет пропущена - ПРОПУЩЕНО НАИМЕНОВАНИЕ`)
                }
                try {
                  groupСode = groupNode.getElementsByTagName('Код')[0].childNodes[0].nodeValue
                } catch (e) {
                  console.log(e)
                  throw new Error(`Столовая ${cafeid}: группа будет пропущена (${groupTitle}) - ПРОПУЩЕН КОД`)
                }
                let group = {
                  title: groupTitle,
                  groupcode: groupСode,
                  cafeid,
                  day
                }
                group.isbudget = this.isBudget(group.title)
                this.setState(statePrefix + ` : ${group.title} @ ${group.groupcode}`)
                const existingGroup = menu[cafeid].groups.find(x => x.groupcode === group.groupcode)
                if (!existingGroup) {
                  this.setState(statePrefix + `: создаём новую группу: ${group.title} @ ${group.groupcode}`)
                  group = (await this.$store.dispatch('sioRequest', {
                    topic: 'org-add-group',
                    pl: group
                  })).group
                  group.products = []
                  menu[cafeid].groups.push(group)
                } else {
                  group = existingGroup
                }
                const products = Array.from(groupNode.getElementsByTagName('Товар')).map(x => {
                  try {
                    let pproductcode
                    let pprice
                    let ptitle
                    try {
                      pproductcode = x.getElementsByTagName('Код')[0].childNodes[0].nodeValue
                    } catch (e) {
                      console.log(e)
                      throw new Error(`Cтоловая ${cafeid}:${groupTitle} некорректный товар пропущен - ПРОПУЩЕН КОД: ${x.innerHTML}`)
                    }
                    try {
                      ptitle = x.getElementsByTagName('Наименование')[0].childNodes[0].nodeValue
                    } catch (e) {
                      console.log(e)
                      throw new Error(`Cтоловая ${cafeid}:${groupTitle} некорректный товар пропущен (код=${pproductcode}) - ПРОПУЩЕНО НАИМЕНОВАНИЕ: ${x.innerHTML}`)
                    }
                    try {
                      pprice = Math.round(100 * parseFloat(x.getElementsByTagName('Цена')[0].childNodes[0].nodeValue))
                    } catch (e) {
                      console.log(e)
                      throw new Error(`Cтоловая ${cafeid}:${groupTitle}:${ptitle} некорректный товар пропущен - ПРОПУЩЕНА ЦЕНА: ${x.innerHTML}`)
                    }
                    const product = {
                      cafeid,
                      day,
                      groupcode: group.groupcode,
                      productcode: pproductcode,
                      price: pprice,
                      title: ptitle
                    }
                    return product
                  } catch (e) {
                    console.log(e)
                    console.log(x)
                    this.log(e, 'error')
                    return null
                  }
                }).filter(x => x !== null)
                for (let product of products) {
                  try {
                    const existingProduct = group.products.find(x => product.productcode === x.productcode)
                    // продукт уже был импортирован
                    if (existingProduct) {
                      if (existingProduct.price !== product.price) {
                        console.log('new price', existingProduct, product)
                        const pl = existingProduct
                        pl.price = product.price
                        pl.cafeid = cafeid
                        product = (await this.$store.dispatch('sioRequest', {
                          topic: 'org-update-products-price',
                          pl
                        })).product
                      }
                    } else {
                      product = (await this.$store.dispatch('sioRequest', {
                        topic: 'org-add-product',
                        pl: product
                      })).product
                    }
                    group.products.push(product)
                  } catch (err) {
                    this.log(err, 'error')
                  }
                }
              } catch (err) {
                this.log(`Столовая ${cafeid}: ошибка загрузки группы`, 'error')
                this.log(err, 'error')
              }
            }
          }
        }
        this.completed = true
        this.setState('готово')
      } catch (err) {
        this.log(err, 'error')
        this.errored = true
      }
    }
  },
  mounted () {
    // testing groups
    [
      '1-11 классы, питание м/о 706',
      'Бюджет',
      'Питание детей ОВЗ (КРО) 706',
      'Питание детей ОВЗ',
      '1-11 классы, питание м/о ФМЛ,ФМЛ(ф) 708',
      'Доп. меню 705',
      'Льготники',
      '1-11 классы, питание м/о 706 (2)',
      'Меню 705 (2)',
    ]
      .map(x => `${x}: ${this.isBudget(x)}`)
      .forEach(x => console.log(x))
  }
}
</script>

<style lang="css">
</style>
